import './comic-screen.scss'

/**
 *  Component Definition
 *
 * @export
 * @class ComicScreen
 * @implements {ng.IComponentOptions}
 */
export class ComicScreen implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: Function = ComicScreenController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./comic-screen.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {
    options: '=',
    isLast: '@',
    isFirst: '@',
  }
}

/**
 * ComicScreen - Controller
 *
 * @export
 * @class ComicScreenController
 */
export class ComicScreenController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */

  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$element', 'AudioManager', 'ProgressManager', 'TrackingManager', '$rootScope', 'PixiManager']
  public options
  public isLast
  public isFirst
  public isSelecting: boolean
  public assetSelectorType: string
  public navReady

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $element: any, public AudioManager: any, public ProgressManager: any, public TrackingManager: any, public $rootScope: any, public PixiManager: any) {
    this.$log.debug('constructor')
  }

  public viewCoverAssets(assetSelectorType: string) {
    this.assetSelectorType = assetSelectorType;
    this.isSelecting = true;
  }


  public goBack() {
    this.isSelecting = false;
    this.AngularServices.$timeout(() => {
      this.assetSelectorType = "";
    }, 500)
  }

  public onNext() {
    this.$log.debug('onNext');
  }

  public onPrevious() {
    this.$log.debug('onPrevious');
  }

  public onEnterStart() {
    this.$log.debug('onEnterStart');
    this.PixiManager.displayPixi = true
    //$('.comic-screen__cover__container__cover').detach().appendTo('.comic-screen__cover__container');
  }
  public onEnterComplete() {
    this.$log.debug('onEnterComplete');
    if (!this.ProgressManager.getCoverBG()){
      this.AppServices.PixiManager.setCover("");
    }
    this.AppServices.PixiManager.updateRender();
  }

  public onExitStart() {
    this.$log.debug("onExitStart")
    this.options.navReady = false
    let sprites = this.AppServices.PixiManager.stickerBoard.children;
    let stickers = []
    for (let s in sprites){
      sprites[s].controls.alpha = 0
      if (sprites[s].isHero === false){
        let sticker = sprites[s].children[0]._texture.baseTexture.imageUrl
        let stickerFile = sticker.split('/')
        let stickerName = stickerFile[stickerFile.length-1].split('.')
        stickers.push(stickerName[0])
      }
    }
  }

  public onExitComplete() {
    this.$log.debug("onExitComplete")
    this.PixiManager.displayPixi = false
  }

  public onResizeCover($event: any) {
    this.$log.debug('onResizeCover', $event);
    //only resize the placeholder images if the user is on the download screen to prevent image from breaking
    if (this.AppServices.ScreenManager.getActiveScreen().title !== 'Download Screen') {
      this.AppServices.PixiManager.resize(document.querySelector('.comic-screen__cover__container__cover'));
    }
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')
    this.options.isLast = this.isLast;
    this.options.isFirst = this.isFirst;
    this.options.$element = this.$element;
    this.options.$ctrl = this;
    this.options.displayBackgrounds = true
    this.AppServices.ScreenManager.comicScreenOptions = this.options

    this.AngularServices.$timeout(() => {
      this.$log.debug('loading pixi')
      this.AppServices.PixiManager.init(document.querySelector('.comic-screen__cover__container__cover'));
    }, 500)


    this.options.backgroundCarousel = this.AppServices.CarouselManager.add(this.AppServices.DataManager.config.carousels.filter((value, index, array) => { return value.key === 'coverBackgrounds' })[0])

    this.options.stickerCarousel = this.AppServices.CarouselManager.add(this.AppServices.DataManager.config.carousels.filter((value, index, array) => { return value.key === 'coverStickers' })[0])
  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/comic-screen/comic-screen.ts
 **/